import { useEffect } from 'react';
import { errorTag } from 'utilities/uTagging';
import { PATH_ERROR_404 } from 'constants/uTagConstants/paths';
import { PUBLICA_URL } from 'constants/index';
import { history } from 'routes/history';

const Error404View = () => {
    useEffect(() => {
        errorTag('', PATH_ERROR_404);
        history.push(PUBLICA_URL + '/page_404');
    }, []);

    return null;
};

export default Error404View;
